import { combineReducers } from "redux";
import app from "./app";
import home from "./home";
import entities from "./entities";
import detail from "./detail";
import search from './search'
import login from './login'
import user from './user'
import purchase from './purchase'


const rootReducer = combineReducers({
    app,
    home,
    entities,
    detail,
    search,
    login,
    user,
    purchase
})

export default rootReducer;